import { Routes, Route, Navigate } from 'react-router-dom'
import { useAuth } from './hooks/useAuth'
import { ThemeProvider } from './contexts/ThemeContext'
import { AuthProvider } from './contexts/AuthContext'
import { LoadingSpinner } from './components/ui/loading-spinner'
import { LoginPage } from './pages/LoginPage'
import { DashboardLayout } from './layouts/DashboardLayout'
import { AdminDashboard } from './pages/admin/AdminDashboard'
import { EmployeeAssignmentsPage } from './pages/employee/EmployeeAssignmentsPage'
import { EmployeeSoftwarePage } from './pages/employee/EmployeeSoftwarePage'
import { DevicesPage } from './pages/DevicesPage'
import { DeviceDetailsPage } from './pages/DeviceDetailsPage'
import { DeviceModelDetailPage } from './pages/DeviceModelDetailPage'
import { ProjectsPage } from './pages/ProjectsPage'
import { SoftwarePage } from './pages/SoftwarePage'
import { SoftwareDetailPage } from './pages/SoftwareDetailPage'
import { SoftwareAccountPage } from './pages/SoftwareAccountPage'
import { UsersPage } from './pages/admin/UsersPage'
import { UserDetailPage } from './pages/admin/UserDetailPage'
import { DeviceRequestsPage } from './pages/DeviceRequestsPage'
import { ProfilePage } from './pages/ProfilePage'
import { NotFoundPage } from './pages/NotFoundPage'

function AppRoutes() {
  const { user, isLoading } = useAuth()

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <LoadingSpinner size="lg" />
      </div>
    )
  }

  if (!user) {
    return (
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    )
  }

  return (
    <Routes>
      <Route path="/login" element={<Navigate to="/" replace />} />
      <Route path="/" element={<DashboardLayout />}>
        {user.role === 'Admin' ? (
          <>
            <Route index element={<AdminDashboard />} />
            <Route path="devices" element={<DevicesPage />} />
            <Route path="devices/models/:modelId" element={<DeviceModelDetailPage />} />
            <Route path="devices/:id" element={<DeviceDetailsPage />} />
            <Route path="software" element={<SoftwarePage />} />
            <Route path="software/accounts/:accountId" element={<SoftwareAccountPage />} />
            <Route path="software/:softwareId" element={<SoftwareDetailPage />} />
            <Route path="projects" element={<ProjectsPage />} />
            <Route path="users" element={<UsersPage />} />
            <Route path="users/:userId" element={<UserDetailPage />} />
            <Route path="requests" element={<DeviceRequestsPage />} />
            <Route path="profile" element={<ProfilePage />} />
          </>
        ) : (
          <>
            <Route index element={<EmployeeAssignmentsPage />} />
            <Route path="assignments" element={<EmployeeAssignmentsPage />} />
            <Route path="requests" element={<DeviceRequestsPage />} />
            <Route path="software" element={<EmployeeSoftwarePage />} />
            <Route path="profile" element={<ProfilePage />} />
          </>
        )}
        <Route path="*" element={<NotFoundPage />} />
      </Route>
    </Routes>
  )
}

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <AppRoutes />
      </AuthProvider>
    </ThemeProvider>
  )
}

export default App
